// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3cMqL","title":"FrontImage_title__2ttW9"};